"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TextInput = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  border: 1px solid #757779;\n  caret-color: ", ";\n  width: 100%;\n\n  ::placeholder {\n    color: rgb(146, 146, 146);\n  }\n\n  :focus {\n    border-color: ", ";\n\n    ::placeholder {\n      color: ", ";\n    }\n  }\n"], ["\n  border: 1px solid #757779;\n  caret-color: ", ";\n  width: 100%;\n\n  ::placeholder {\n    color: rgb(146, 146, 146);\n  }\n\n  :focus {\n    border-color: ", ";\n\n    ::placeholder {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
}, function (props) {
  return props.placeHolderColor ? props.placeHolderColor : 'transparent';
});
exports.TextInput = TextInput;
TextInput.displayName = 'Input';
TextInput.defaultProps = {
  color: 'black',
  fontSize: '4',
  px: '4',
  py: '3'
};
var templateObject_1;